module.exports = __webpack_public_path__ + "static/media/parking-brown.0c19fe49.svg";